import Reflux from "reflux";

import Chip from "@javascript/reactComponents/lds/chips/Chip";
import { FacetSearchCompanyRelationshipActions } from "@javascript/stores/actions/facetSearch/companyRelationshipActions";
import FacetSearchStore from "@javascript/stores/facetSearchStore";

const FacetSearchCriteriaRelationship = createReactClass({
  mixins: [
    Reflux.connectFilter(FacetSearchStore, function(data) { return data.relationships })
  ],

  getInitialState() {
    return { ...(FacetSearchStore.data.relationships) }
  },

  render () {
    const { selected, salesforceCurrentlyProcessing, authorizedSalesForce } = this.state;

    if (selected == null) return null

    let relationshipsSelected = selected.filter((rel) => rel !== "exclude_muted_companies");

    const shouldDisplay = (salesforceCurrentlyProcessing && authorizedSalesForce) && relationshipsSelected.length !== 0

    if (!shouldDisplay) return null

    const lastRelIndex = relationshipsSelected.length - 1;
    const originalRels = (Zymewire.original_feed_query || {}).relationships || []

    relationshipsSelected = _.sortBy(relationshipsSelected, (rel) => -rel.length)

    relationshipsSelected = relationshipsSelected.map((relationship, index) => {
      return {
        name: Zymewire.relationship_properties[relationship],
        value: relationship,
        last: lastRelIndex === index,
        locked: _.contains(originalRels, relationship),
      }
    });

    const componentFor = (prop) => {

      const conjunction = prop.value === 'exclude_recent_sponsor' ? ' AND' : ' OR'

      return <RelationshipEntry
        conjunction={conjunction}
        key={prop.value}
        last={prop.last}
        locked={prop.locked}
        name={prop.name}
        value={prop.value}
      />;

    };

    return(
      <>
        { relationshipsSelected.map((prop) => componentFor(prop)) }
      </>
    );
  }
});

const RelationshipEntry = ({
  conjunction,
  last,
  locked,
  name,
  value,
}) => {

  let removeRelationship = () => {
    FacetSearchCompanyRelationshipActions.removeCompanyRelationship(value)
    return false;
  };

  const label = (
    <>
      {Zymewire.facet_search_filters.company_relationship}: {name}
      {!last && <b> {conjunction}</b>}
    </>
  );

  return (
    <Chip
      className="search_filter_applied_chip"
      label={label}
      leadingIcon="company_relationship"
      size="small"
      {...!locked && {
        trailingIcon: "cancel",
        trailingIconClassName: "search_filter_applied_trailing_icon",
        trailingIconOnClick: removeRelationship,
      }}
      variant="secondary"
    />
  );
};

window.FacetSearchCriteriaRelationship = FacetSearchCriteriaRelationship;
export default FacetSearchCriteriaRelationship;
